<template>
  <div class="send-record">
    <div class="main-title">
      <p>设备轨迹</p>
    </div>
    <div class="main-body">
      <el-form
        :inline="true"
        class="demo-form-inline"
      >
        <el-form-item :label="activeTab === 'bicycle' ? $t('lang.ECU Number') : '账户编号/手机号'">
          <el-input v-model="param"
                    :placeholder="activeTab === 'bicycle' ? $t('lang.Please enter ECU number') : ''"
                    clearable maxlength="50"/>
        </el-form-item>
      </el-form>
      <el-tabs v-model="activeTab">
        <!--<el-tab-pane label="电池轨迹" name="battery">
          <div class="list">
            <span>时间</span>
            <el-date-picker
              v-model="startTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              placeholder="开始日期"
            ></el-date-picker>
            -
            <el-date-picker
              v-model="endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              placeholder="结束日期"
            ></el-date-picker>
            <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
          </div>
          <div class="amap-page-container">
            <table class="info-table">
              <tr>
                <td class="name">归属对象：</td>
                <td class="long">{{batteryInfo.belongTarget}}</td>
                <td class="short">商品类型：电池</td>
                <td class="name">兑换状态：</td>
                <td>{{batteryInfo.redeemStatus}}</td>
                <td class="name">凭证状态：</td>
                <td>{{batteryInfo.status}}</td>
              </tr>
            </table>
            <el-amap vid="batteryTrack" :zoom="zoom" :center="battCenter">
              <el-amap-polyline v-for="(polyline,index) in battPolylineList"
                                :editable="polyline.editable"
                                :path="polyline.path"
                                :strokeColor="polyline.strokeColor"
                                :stroke-weight="polyline.strokeWeight"
                                :z-index="polyline.zIndex"
                                :vid="index"
                                :key="index"
              ></el-amap-polyline>
              <el-amap-marker
                v-for="(marker, index) in battMarkers"
                :position="marker.position"
                :visible="marker.visible"
                :draggable="marker.draggable"
                :vid="index"
                :title="marker.label.content"
                :events="marker.events"
                :icon="marker.icon"
                :offset="marker.offset"
                :key="index"
              ></el-amap-marker>
            </el-amap>
          </div>
          <div class="table-box">
            <table class="table-custom">
              <thead>
              <tr>
                <th width="145px">时间</th>
                <th width="170px">电池编号</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody v-if="batteryList.length>0">
              <tr v-for="(item,index) in batteryList" :key="index">
                <td v-html="item.startTime+'至<br/>'+item.endTime"></td>
                <td>{{item.batteryNo}}</td>
                <td>
                  <div class="text-btn fixed-width-75" @click="getBatteryTrack(index)">查看轨迹</div>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="3">暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>-->
        <el-tab-pane :label="$t('lang.Electric vehicle trajectory')" name="bicycle">
          <el-form
            :inline="true"
            class="demo-form-inline"
          >
            <el-form-item :label="$t('lang.Creation time')">
              <el-date-picker
                v-model="timeArr"
                type="datetimerange"
                range-separator="-"
                value-format="timestamp"
                :start-placeholder="$t('lang.start time')"
                :end-placeholder="$t('lang.end time')">
              </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="onQueryBicycleBtnClick">{{ $t('lang.Inquire') }}</el-button>
          </el-form>
          <div class="amap-page-container2">
            <div class="info-box">
              <div class="info-item">
                {{ $t('lang.Attribution') }}：{{bicycleInfo.belongTarget}}
              </div>
              <div class="info-item">
                {{ $t('lang.type') }}：{{ $t('lang.E-Motorcycle') }}
              </div>
              <div class="info-item">
                {{ $t('lang.Exchange status') }}：{{bicycleInfo.redeemStatus}}
              </div>
              <div class="info-item">
                {{ $t('lang.Credential status') }}：{{bicycleInfo.status}}
              </div>
            </div>

            <el-amap vid="bicycleTrack" :zoom="zoom" :center="bicyCenter">
              <el-amap-polyline
                :editable="bicyPolyline.editable"
                :path="bicyPolyline.path"
                :strokeColor="bicyPolyline.strokeColor"
              ></el-amap-polyline>
              <el-amap-marker
                v-for="(marker, index) in bicyMarkers"
                :position="marker.position"
                :visible="marker.visible"
                :draggable="marker.draggable"
                :vid="index"
                :title="marker.label.content"
                :events="marker.events"
                :icon="marker.icon"
                :offset="marker.offset"
                v-bind:key="index"
              ></el-amap-marker>
            </el-amap>
          </div>

          <div class="table-box">
            <table class="table-custom">
              <thead>
              <tr>
                <th>{{ $t('lang.Equipment number') }}</th>
                <th>{{ $t('lang.Operation Type') }}</th>
              </tr>
              </thead>
              <tbody v-if="bicycleList.length>0">
              <tr v-for="(item,index) in bicycleList" :key="index">
                <td>{{item.number}}</td>
                <td>
                  <div class="text-btn fixed-width-75" @click="getBicycleTrack(item)">{{ $t('lang.View') }}</div>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="2">{{ $t('lang.No data') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: "deviceTrack",
  data() {
    return {
      activeTab:'bicycle',
      param: '',
      startTime: "",
      endTime: "",
      bicycleStartTime: "",
      bicycleEndTime: "",
      zoom: 15,
      battCenter: [120.15, 30.28],
      bicyCenter: [120.15, 30.28],
      battMarkers: [],
      battTrackPointList: [],
      battTrackPoint: {},
      battPolylineList: [],
      battPolyline: {
        path: [],
        editable: false,
        zIndex: 50,
        strokeWeight: '2'
      },
      bicyMarkers: [],
      bicyTrackPointList: [],
      bicyTrackPoint: {},
      bicyPolyline: {
        path: [],
        editable: false,
      },
      batteryList:[],
      bicycleList:[],
      batteryInfo:{},
      bicycleInfo:{},
      seletedIndex: null
    };
  },
  computed: {
    timeArr: {
      set(e) {
        if(e && e.length) {
          this.bicycleStartTime = e[0]
          this.bicycleEndTime = e[1]
        } else {
          this.bicycleStartTime =''
          this.bicycleEndTime = ''
        }
        console.log(this.searchParams)
      },
      get() {
        if(this.bicycleStartTime && this.bicycleEndTime) {
          return [this.bicycleStartTime, this.bicycleEndTime]
        } else {
          return []
        }
      }
    }
  },
  mounted() {
    this.startTime = new Date(Utils.getCurrentDate() + ' 00:00').getTime();
    this.endTime = new Date(Utils.getCurrentDate() + ' 23:59').getTime();
    this.bicycleStartTime = this.startTime;
    this.bicycleEndTime = this.endTime;
  },
  methods: {
    onQueryBtnClick(){
      if((this.endTime - this.startTime) < 0){
        this.$message({
          type: 'warning',
          message: '开始时间不能大于结束时间！',
          center: true
        })
        return;
      }
      this.queryUserDeviceTrack();
    },
    onQueryBicycleBtnClick(){
      if(this.bicycleInfo.controllerNo){
        if((this.bicycleStartTime - this.bicycleEndTime) > 86400000){
          this.$message({
            type: 'warning',
            message: this.$t('lang.One day at most'),
            center: true
          })
          return;
        }
        this.getBicycleLocaion();
      }else{
        this.queryUserDeviceTrack('bicycle');
      }
    },
    queryUserDeviceTrack(type) {
      let self = this;
      let params = {
        deviceType: '3',
        param: this.param,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      if(this.activeTab === 'battery') {
        params.deviceType = '3'
      } else if (this.activeTab === 'bicycle') {
        params.deviceType = '6'
      }
      this.$http.post('/managementPlatform/electricity/queryUserDeviceTrack', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || this.$t('lang.Query failed'),
            center: true
          });
          return;
        }
        self.batteryList = res.mdata.battery || [];
        self.bicycleList = res.mdata.electricBycycle || [];
        self.battTrackPointList = [];
        self.battPolylineList = [];
        self.battMarkers = [];
        self.batteryList.forEach(v => {
          self.queryBatteryTrack(v);
        })
        if(self.batteryList.length > 0){
          self.batteryInfo = self.batteryList[0];
        }
        if(self.bicycleList.length > 0){
          self.bicycleInfo = res.mdata.electricBycycle[0];
        }
        if(type=='bicycle' && self.$route.path === '/managePage/deviceTrack'){
          setTimeout(() => {
            self.onQueryBicycleBtnClick();
          }, 2000)
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    getBicycleLocaion() {
      let self = this;
      self.bicyTrackPoint = {};
      self.bicyPolyline.path = [];
      self.bicyMarkers = [];
      const loading = this.$loading({
        target: document.getElementById('bicycleTrack'),
        lock: true,
        text: this.$t('lang.Loading'),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let params = {
        startTime: this.startTime/1000,
        endTime: this.endTime/1000,
        controllerNo: this.bicycleInfo.controllerNo
      };
      this.$http.post('/managementPlatform/electricity/queryElectricBicycleLocation', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        loading.close();
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || this.$t('lang.Query failed'),
            center: true
          });
          return;
        }
        self.bicyTrackPointList = res.mdata.trackPoint;
        let path = [];
        let markers = [];
        self.bicyTrackPointList.forEach((element, index) => {
          path.push([element.coordinate[1], element.coordinate[0]]);
          markers.push({
            position: [element.coordinate[1], element.coordinate[0]],
            visible: true,
            draggable: false,
            label: {
              content: element.miles,
              offset: [-20, -40]
            },
            events: {
              click: e => {
                self.bicyTrackPoint = self.bicyTrackPointList[index];
                if (self.seletedIndex != null) {
                  self.bicyMarkers[self.seletedIndex].icon =
                    "/static/ic-circle-unselected.png";
                  self.bicyMarkers[self.seletedIndex].offset = [-5, -5];
                }
                self.bicyMarkers[index].icon = "/static/ic-circle-selected.png";
                self.bicyMarkers[index].offset = [-7, -7];
                self.seletedIndex = index;
              }
            },
            icon: "/static/ic-none.png",
            offset: [-5, -5]
          });
        });
        self.bicyPolyline.path = path;
        self.bicyPolyline.strokeColor = "#FA0000FF";
        if (path.length > 0) {
          self.bicyCenter = path[Math.floor(path.length / 2)];
        }
        self.bicyMarkers = markers;
      }).catch(function (response) {
        loading.close();
        console.log(response);
      });
    },
    queryBatteryTrack(item) {
      let self = this;
      self.seletedIndex = null;
      const loading = this.$loading({
        target: document.getElementById('batteryTrack'),
        lock: true,
        text: this.$t('lang.Loading'),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let params = {
        deviceType: '3',
        param: item.batteryNo,
        startTime: item.startTime,
        endTime: item.endTime
      };
      if(this.activeTab === 'battery') {
        params.deviceType = '3'
      } else if (this.activeTab === 'bicycle') {
        params.deviceType = '6'
      }
      this.$http.post("/managementPlatform/electricity/queryBatteryTrack",this.$qs.stringify(params))
        .then(function (response) {
          loading.close();
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || this.$t('lang.Query failed'),
              center: true
            });
            return;
          }
          let list = res.ldata;
          self.battTrackPointList.push(list);
          let path = [];
          let markers = self.battMarkers;
          list.forEach((element, index) => {
            path.push([element.coordinate[0], element.coordinate[1]]);
            // markers.push({
            //     position: [element.coordinate[0], element.coordinate[1]],
            //     visible: true,
            //     draggable: false,
            //     title: element.miles,
            //     events: {
            //         click: e => {
            //             // self.battTrackPoint = self.battTrackPointList[index];
            //             // if (self.seletedIndex != null) {
            //             //     self.battMarkers[self.seletedIndex].icon =
            //             //         "/static/ic-circle-unselected.png";
            //             //     self.battMarkers[self.seletedIndex].offset = [-5, -5];
            //             // }
            //             // self.battMarkers[index].icon = "/static/ic-circle-selected.png";
            //             // self.battMarkers[index].offset = [-7, -7];
            //             // self.seletedIndex = index;
            //         }
            //     },
            //     icon: "/static/ic-none.png",
            //     offset: [-5, -5]
            // });
          });
          let polyline = {
            path: [],
            editable: false,
            zIndex: 50,
            strokeWeight: 2
          }
          polyline.path = path;
          polyline.strokeColor = "#FF0000";
          if (path.length > 0) {
            self.battCenter = path[Math.floor(path.length / 2)];
          }
          self.battPolylineList.push(polyline);
          self.battMarkers = markers;
        })
        .catch(function (response) {
          loading.close();
          console.log(response);
        });
    },
    getBatteryTrack(showIndex) {
      let self = this;
      let markers = [];
      self.battPolylineList.forEach((v, index) => {
        if(showIndex == index){
          v.strokeColor = "#3355f7";
          v.strokeWeight = 3;
          v.zIndex = 100;
        }else {
          v.strokeColor = "#ff0000";
          v.strokeWeight = 2;
          v.zIndex = 50;
        }
      })
      self.battTrackPointList.forEach((v,index)=>{
        if(showIndex == index){
          v.forEach(vv=>{
            markers.push({
              position: [vv.coordinate[0], vv.coordinate[1]],
              visible: true,
              draggable: false,
              label: {
                content: vv.miles,
                offset: [-20, -40]
              },
              events: {
                click: e => {
                }
              },
              icon: "/static/ic-none.png",
              offset: [-5, -5]
            });
          })
        }
      })
      self.battMarkers = markers;
    },
    getBicycleTrack(item) {
      this.bicycleInfo = item;
      this.getBicycleLocaion();
    },
    getAddress() {
      let self = this;
      if (
        !this.trackPoint.coordinate ||
        this.trackPoint.coordinate.length != 2
      ) {
        return;
      }
      let params = {
        longitude: this.trackPoint.coordinate[0],
        latitude: this.trackPoint.coordinate[1],
        type: "0"
      };
      this.$http
        .post("/post/getAddress", this.$qs.stringify(params))
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || this.$t('lang.Query failed'),
              center: true
            });
            return;
          }
          let address = res.mdata.address;
          self.address = address.formatted_address;
          if (!address.formatted_address) {
            self.address = address.province + address.city + address.district;
          }
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-body{
  width: 1180px;
}
.info-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.list {
  width: 1180px;
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}
.table-box{
  height: 330px;
  position: absolute;
  width: 440px;
  top: 135px;
  right: 0;
  overflow-y: auto;
}
.info-table{
  width: 100%;
  margin: 10px 0;
  .long{
    width: 200px;
  }
  .short{
    width: 110px;
  }
  .name{
    width: 70px;
  }
}
.table-custom {
  position: absolute;
  width: 430px;
  right: 0;
  top: 0;
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #bee6b3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.amap-page-container, .amap-page-container2 {
  width: 740px;
  height: 530px;
}

.marker-icon {
  width: 11px;
  height: 11px;
  background: rgba(250, 0, 0, 1);
}

.marker-detail {
  position: relative;
  top: -180px;
  left: 10px;
  z-index: 999;
  width: 351px;
  height: 150px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.32);
  border-radius: 5px;
  padding-top: 15px;
  padding-left: 18px;
  padding-right: 18px;
}

.marker-detail .seq-info {
  width: 100%;
  height: 18px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(119, 119, 119, 1);
  line-height: 18px;
}

.marker-detail .mile-info {
  width: 100%;
  height: 30px;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(39, 39, 39, 1);
  line-height: 30px;
  margin-top: 20px;
}

.marker-detail .row {
  width: 100%;
  height: 18px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(119, 119, 119, 1);
  line-height: 18px;
  margin-top: 10px;
}

.unselected-marker {
  width: 19px;
  height: 19px;
  background: rgba(232, 229, 213, 1);
  border: 2px solid rgba(0, 48, 250, 1);
}
</style>

<style>
.amap-marker-label {
  width: 48px;
  height: 28px;
  background: rgba(255, 223, 0, 1);
  border-radius: 3px 3px 3px 0px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(39, 39, 39, 1);
  line-height: 28px;
  border: none;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/deviceTrack.vue